import { render, staticRenderFns } from "./SimpleSkeletonCard.vue?vue&type=template&id=0b649006&scoped=true"
import script from "./SimpleSkeletonCard.vue?vue&type=script&lang=js"
export * from "./SimpleSkeletonCard.vue?vue&type=script&lang=js"
import style0 from "./SimpleSkeletonCard.vue?vue&type=style&index=0&id=0b649006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b649006",
  null
  
)

export default component.exports